<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveDetails" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalOrderVisible" :vm-title="$t('strings.purchase_order')")
    vm-tabs(v-model='tap')
      vm-tab(vm-label="Datos Generales" vm-alignment="fixed" class="tab")
        vm-row(class="purchase-section" vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
          vm-col(v-if="isStore" vm-justify="center", vm-align="center", vm-w=12)
            vm-textarea(class="custom__note" height="100px" :placeholder='$t("purchase_orders.placeholder_justify")' :danger="$v.form.justify.$invalid && $v.form.justify.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.supplier_display') })" v-model="form.justify" @keyup.enter="setBullets(form.notes)" type="text" :label='$t("purchase_orders.justify")')
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group(class="purchase-section__input")
              vm-select(autocomplete :placeholder='$t("purchase_orders.supplier_placeholder")' :danger="$v.form.supplier_id.$invalid && $v.form.supplier_id.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.supplier_display') })" v-model="form.supplier_id" :label='$t("purchase_orders.supplier_display")')
                vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in suppliers")
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group(class="purchase-section__input")
              vm-input(autofocus :placeholder='$t("purchase_orders.email_placeholder")' :danger="$v.form.email.$invalid && $v.form.email.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.email') })" v-model="form.email" :label='$t("purchase_orders.email")')
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group(class="purchase-section__input")
              vm-input(autofocus :placeholder='$t("purchase_orders.shipping_address_placeholder")' :danger="$v.form.shipping_address.$invalid && $v.form.shipping_address.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.shipping_address') })" v-model="form.shipping_address" :label='$t("purchase_orders.shipping_address")')
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group(class="purchase-section__input")
              vm-input(autocomplete :placeholder='$t("purchase_orders.delivery_time_placeholder")' :danger="$v.form.delivery_time.$invalid && $v.form.delivery_time.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.delivery_time') })" v-model="form.delivery_time" :label='$t("purchase_orders.delivery_time")')
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group(class="purchase-section__input")
              vm-input(autocomplete :placeholder='$t("purchase_orders.deadline_placeholder")' :danger="$v.form.deadline.$invalid && $v.form.deadline.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.deadline') })" v-model="form.deadline" :label='$t("purchase_orders.deadline")')
          vm-col(vm-justify="left", vm-align="center", vm-w=6)
            b-form-group(class="purchase-section__input")
              vm-select(autocomplete :placeholder='$t("purchase_orders.freight_placeholder")' :danger="$v.form.freight.$invalid && $v.form.freight.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.freight') })" v-model="form.freight" :label='$t("purchase_orders.freight")')
                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in freight")
          vm-col(vm-justify="left", vm-align="center", vm-w=6)
            b-form-group.div__quotation
              vm-input(v-if="Boolean(form.freight)" type="currency" autofocus :danger="$v.form.total_freight.$invalid && $v.form.total_freight.$model" :danger-text="$t('validation.required', { attribute: $t('quotations.total_freight') })" v-model="form.total_freight" :label='$t("quotations.total_freight")')
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group
              label.vm-input--label {{ $t('quotations.tax_type') }}
              .radio-section
                .radio-item
                  input.radio-margin(type="radio" value=0 id="tax_0" v-model="form.tax_type")
                  label.radio-label(for="tax_0") 0%
                .radio-item
                  input.radio-margin(type="radio" value=.08 id="tax_8" v-model="form.tax_type")
                  label.radio-label(for="tax_8") 8%
                .radio-item
                  input.radio-margin(type="radio" value=.16 id="tax_16" v-model="form.tax_type")
                  label.radio-label(for="tax_16") 16%
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group
              label.vm-input--label {{ $t('quotations.currency') }}
              .radio-section.d-flex.margin-left
                .radio-item(v-for='(currency, index) in currencies' :key="index")
                  input(type="radio" :value="currency.id" :id="currency.id" v-model="form.currency_id")
                  label.radio-margin(:for="currency.id") {{ currency.code }}
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            vm-textarea(class="custom__note" height="60px" :placeholder='$t("purchase_orders.notes")' v-model="form.notes" @keyup.enter="setBullets(form.notes)" type="text" :label='$t("purchase_orders.notes")')
      vm-tab(vm-label="Importar Archivo" vm-alignment="fixed" class="tab")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          .attached-custom
            .attached-custom__card(@dragover='dragover' @dragleave='dragleave' @drop='drop')
              div(class="attached-custom__card__placeholder" v-if='!this.filelist.length')
                vm-icon(icon="cloud-upload-outline" size="2rem")
                label(for='files')
                  span {{ $t('quotations.description_attached') }}
                vm-button(@click="onDialogFileOpen" size="medium") Buscar archivo
              div(class="attached-custom__card__grid" v-else='')
                div(class="attached-custom__card__grid__item" v-for='(file, index) in filelist' :key="index")
                  header
                    img(:src='checkFormat(file.name)' @click="onShowFile(file)")
                    .attached-custom__card__grid__item__dropdown
                      vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                        vm-button(type="flat" icon="more-vertical" color="#afbbc6" size="small")
                        vm-dropdown-menu
                          vm-dropdown-item.d-flex.justify-content-between(@click="remove(index, file)")
                            vm-icon(icon="trash-2-outline")
                            slot &nbsp;{{ $t('strings.delete') }}
                  footer
                    img(:src='checkFormat(file.name)')
                    span {{ getFileNameFormated(file.name) }}
            input(class="attached-custom__file" id="files" multiple='' type='file' name='fields[files][]' @change='onChange' ref='file' accept='.pdf,.dwg,.xls,.spread,.dxf,.xlsx,.csv')
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { required, email, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'ModalOrder',
  props: {
    isStore: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    form: {
      files: [],
      deadline: '',
      delivery_time: ''
    },
    freight: [
      {
        text: 'Si',
        value: 1
      },
      {
        text: 'No',
        value: 0
      }
    ],
    filelist: []
  }),
  validations () {
    return {
      form: {
        supplier_id: {
          required
        },
        email: {
          required,
          email
        },
        shipping_address: {
          required
        },
        delivery_time: {
          required
        },
        deadline: {
          required
        },
        freight: {
          required
        },
        total_freight: {
          required: requiredIf(() => this.form.freight)
        },
        justify: {
          required: requiredIf(() => this.isStore)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalOrderVisible',
      'purchaseOrder',
      'suppliers',
      'currencies',
      'requisition'
    ])
  },
  watch: {
    isModalOrderVisible (flag) {
      if (flag) {
        this.loadSuppliers({ page: 1 })
        this.loadCurrenciesCatalog()
        if (this.isStore) {
          this.form = {
            project_id: this.requisition.project_id,
            requisition_id: this.requisition.id,
            supplier_id: 1,
            email: 'pma@gmail.com',
            shipping_address: 'PMA',
            delivery_time: 0,
            deadline: 0,
            freight: 0,
            currency_id: 1,
            tax_type: 0
          }
        } else {
          this.form = {
            project_id: this.requisition.project_id,
            requisition_id: this.requisition.id,
            notes: '•',
            freight: 0,
            currency_id: 1,
            tax_type: 0,
            delivery_time: 15,
            deadline: 15
          }
        }
      }
    },
    'form.freight' () {
      if (!this.form.freight) { this.form.total_freight = 0.00 }
    }
  },
  methods: {
    ...mapActions([
      'importRequisitionDetail',
      'setModalOrderVisible',
      'loadSuppliers',
      'loadCurrenciesCatalog',
      'savePurchase'
    ]),
    onDialogFileOpen () {
      this.$refs.file.click()
    },
    onShowFile (file) {
      const ext = file.name.split('.').pop()
      if (file.id && ext === 'pdf') {
        this.$viewer.show({
          urlFile: file.file_url,
          mime: file.mime_type,
          name: file.name,
          color: '#FFF'
        })
      } else if (file.id && ext !== 'pdf') {
        this.openFile(file.file_url)
      }
    },
    onChange () {
      this.filelist.push(...this.$refs.file.files)
      this.$refs.file.value = ''
      this.form.files = this.filelist
    },
    async remove () {
      this.form.files = []
      this.filelist.splice(0, 1)
    },
    dragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('attached-custom__card--dragover')) {
        event.currentTarget.classList.add('attached-custom__card--dragover')
      }
    },
    dragleave (event) {
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    checkFormat (file) {
      const type = file.split('.').pop()
      if (type === 'dwg' || type === 'dxf') {
        return require('@/assets/icons/auto.png')
      } else if (type === 'pdf') {
        return require('@/assets/icons/pdf.svg')
      } else if (type === 'xls' || type === 'spread' || type === 'xlsx' || type === 'csv') {
        return require('@/assets/icons/excel.svg')
      } else {
        return require('@/assets/icons/pdf.svg')
      }
    },
    async saveDetails () {
      await this.savePurchase({ form: { ...this.form, details: this.purchaseOrder.details } })
    },
    setBullets (payload) {
      const bullet = '•'
      this.form.notes = `${payload}${bullet} `
    },
    close () {
      this.setModalOrderVisible(false)
    }
  }
}
</script>

<style lang="scss">
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
.purchase-section {
  &__input {
    margin: 5px;
  }
  &__note {
    label {
      color: black;
      font-weight: bold;
    }
  }
}
.attached-custom {
  margin: 10px 0;
  &__card {
    background-color: #F2F4F7;
    display: flex;
    min-height: 100px;
    border-radius: 8px;
    border: 3px dashed #B1B1B1;
    padding: 10px 20px;
    position: relative;
    &--dragover {
      background-color: rgba($color: var(--success), $alpha: 0.5);
      border: 3px dashed rgba($color: var(--success), $alpha: 1.0);
    }
    &__placeholder {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & label {
        margin: 16px 0 10px 0;
        & span {
          font-size: 14px;
          font-weight: 400;
          color: #8A8A8A;
        }
      }
      & button {
        font-weight: 700;
        font-size: 16px;
      }
    }
    &__grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;
      &__item {
        background-color: white;
        border-radius: 0.5em;
        box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        cursor: pointer;
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          display: flex;
          justify-content: center !important;
          align-items: center;
          height: 125px;
          border-bottom: 1px solid #f0f0f0;
          padding: 10px;
          position: relative;
          img {
            width: 50px;
          }
        }
        & footer {
          padding: 10px;
          display: flex;
          & img {
            width: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  &__file {
    display: none;
  }
  &__upload {
    position: absolute;
    bottom: 5px;
    right: 5px;
    border-radius: 50%;
  }
  // remove clasess
  &__text {
    font-weight: bold;
  }
  &__note {
    label {
      color: black;
      font-weight: bold;
    }
  }
}
[v-cloak] {
  display: none;
}
.radio-section {
 display: flex;
 .radio-item {
   margin: 5px;
  }
}
</style>
